import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../../../components/Icon';

function TBody({
  rowData,
  columnData,
  renderCell,
  actions,
  ...props
}) {
  return (
    <tbody
      className="AdminTableTBody"
      {...props}
    >
      {
        rowData.map(row => (
          <tr
            key={row.id}
            className={`AdminTableTBody__tr ${row.isSelected ? ' AdminTableTBody__tr--selected' : ''}`}
          >
            {
              columnData && columnData.map(column => (
                <td
                  key={column.name}
                  className={`AdminTableTBody__td ${column.boldPrimary ? ' AdminTableTBody__td--bold-primary' : ''}`}
                  style={column.style ? column.style : {}}
                >
                  {renderCell(column.name, row[column.name], row)}
                </td>
              ))
            }

            {
              actions && actions.map(action => (
                <td
                  key={action.name}
                  className="AdminTableTBody__td AdminTableTBody__td--edit"
                  onClick={() => { action.actionFn(row); }}
                >
                  <Icon name={action.iconName} />
                </td>
              ))
            }

          </tr>
        ))
      }
    </tbody>
  );
}

TBody.propTypes = {
  rowData: PropTypes.array,
  columnData: PropTypes.array,
  renderCell: PropTypes.func,
  onRowSelect: PropTypes.func,
};

TBody.defaultProps = {
  rowData: [],
  columnData: [],
  renderCell: () => {},
  onRowSelect: () => {},
};

export default TBody;
